module.exports = __webpack_public_path__ + "img/dash_quickicon_1.52da0b2d.svg";